import "./map.css";

export default function MapSection() {
  return (
    <section className="map-section">
      <h2 className="map-title">LOKACIJA EVENTA</h2>

      <div className="map-container">
        <iframe
            title="Pila Lokacija"
            src="https://www.google.com/maps?q=Pila,Hrvatska&output=embed"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
      </div>
    </section>
  );
}